export default __webpack_public_path__ + "static/media/comment.58aa9c75.svg";